import type { Event as SentryEvent } from "@sentry/react";

const JAVA_OBJECT_GONE = /Java object is gone/i;
const NAV_PERF_LOGGER = /navigation_performance_logger_android/i;

function exceptionMessages(event: SentryEvent): string[] {
  return (event.exception?.values ?? [])
    .flatMap((ex) => [ex.value, ex.type].filter((v): v is string => Boolean(v)));
}

function framesIncludeNavPerfLogger(event: SentryEvent): boolean {
  for (const ex of event.exception?.values ?? []) {
    for (const frame of ex.stacktrace?.frames ?? []) {
      const filename = frame.filename ?? frame.abs_path ?? "";
      if (NAV_PERF_LOGGER.test(filename)) return true;
    }
  }
  return false;
}

/** Instagram/Facebook Android in-app browser instrumentation noise. */
export function isInAppBrowserNativeBridgeNoise(event: SentryEvent): boolean {
  if (!exceptionMessages(event).some((message) => JAVA_OBJECT_GONE.test(message))) {
    return false;
  }
  return framesIncludeNavPerfLogger(event);
}
